export default "__VITE_ASSET__Bt7rQ6$$__"